// extracted by mini-css-extract-plugin
export default {"TabSystem_horizontal_tabs":"AppTabSystem_TabSystem_horizontal_tabs__ie4NB","TabSystem_vertical_tabs":"AppTabSystem_TabSystem_vertical_tabs__SXL8V"};